import {makeReactContext} from 'lib/makeReactContext';
import {
  FlowchartNode,
  TaskSchemaDomainData,
  TaskSchemaNode,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';

export interface NodesContextValue {
  nodes: Array<FlowchartNode>;
  // startNode may not be present in the nodes array.  It is here to provide
  // information for map from start sections
  startNode: TaskSchemaDomainData | null;
  endNode: TaskSchemaNode | null;
}

/** Context to provide the full set of nodes along with the start and end node */
export const NodesContext = makeReactContext<NodesContextValue>(
  () => ({
    nodes: [],
    startNode: null,
    endNode: null,
  }),
  'NodesContext'
);
